import e from "react";
import t from "./index271.mjs";
import m from "./index272.mjs";
const n = () => /* @__PURE__ */ e.createElement("div", { className: m.no_image, "data-testid": "no-images" }, /* @__PURE__ */ e.createElement(t, null));
export {
  n as EmptyImage
};
